import script from "./audio.vue?vue&type=script&setup=true&lang=js"
export * from "./audio.vue?vue&type=script&setup=true&lang=js"

import "./audio.vue?vue&type=style&index=0&id=3642793e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3642793e"]])

export default __exports__